import * as yup from 'yup';

import { CONTACT_STEPS, REQUEST_TYPE } from '../../constants/contact';

export const requestTypeSchema = yup.object().shape({
  requestType: yup.string().required('required').oneOf(Object.values(REQUEST_TYPE), 'required'),
});

export const contactInfoSchema = yup.object().shape({
  contactEmail: yup.string().email('invalidEmail').required('required'),
});

export const descriptionSchema = yup.object().shape({
  description: yup.string().required('required').min(20, 'min20'),

  bugTime: yup.string().when('requestType', {
    is: REQUEST_TYPE.BUG_REPORT,
    then: (schema) => schema.nullable(),
    otherwise: (schema) => schema.nullable(),
  }),

  bugProjectName: yup.string().when('requestType', {
    is: REQUEST_TYPE.BUG_REPORT,
    then: (schema) => schema.optional(),
    otherwise: (schema) => schema.optional(),
  }),

  supportTopic: yup.string().when('requestType', {
    is: REQUEST_TYPE.SUPPORT,
    then: (schema) => schema.required('required'),
    otherwise: (schema) => schema.optional(),
  }),
});

export const contactFormSchema = () =>
  yup.object().shape({
    ...requestTypeSchema.fields,
    ...contactInfoSchema.fields,
    ...descriptionSchema.fields,
  });

export const validateStep = async (step, values) => {
  let schema;

  switch (step) {
    case CONTACT_STEPS.TYPE_OF_REQUEST:
      schema = requestTypeSchema;
      break;
    case CONTACT_STEPS.CONTACT_INFORMATION:
      schema = contactInfoSchema;
      break;
    case CONTACT_STEPS.REQUEST_DESCRIPTION:
      schema = descriptionSchema;
      break;
    default:
      schema = yup.object().shape({});
  }

  try {
    await schema.validate(values, { abortEarly: false });
    return {};
  } catch (errors) {
    return errors.inner?.reduce((acc, error) => {
      acc[error.path] = error.message;
      return acc;
    }, {});
  }
};
